module.exports = __webpack_public_path__ + "static/media/MRI.5e288166.jpg";